import React from 'react';

const Header = () => (
  <header className="header">
    <h1>BookStore</h1>
    <nav className="nav">
      <a href="/">Books</a>
      <a href="/Categories">categories</a>
    </nav>
  </header>
);

export default Header;
